import { Navigate } from 'react-router-dom'
import useAuthContext from '../context/AuthContext'

function PrivateRoute({ children }) {
  const { isAuthenticated , loading} = useAuthContext();
  if (loading)
    return <div className="section">Loading...</div>;
  return isAuthenticated ? children : <Navigate to="/login" replace />
}

export default PrivateRoute